export default __webpack_public_path__ + "static/media/portfolio3.72fd2843.png";